import React, { useEffect, useState } from "react";
import Arrow from "assets/images/Arrow 1.svg";
import LabResultRow from "./LabResultRow";
import UserLabResultMobile from "./UserLabResultMobile";

const UserLabResult = ({ labTests }: any) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1060);

  let count = 0;

  const incrementCount = () => {
    count += 1;
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1024);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  return (
    <>
      {isMobile ? (
        <>
          {labTests && labTests.length !== 0 ? (
            labTests.map((t: any) => (
              <UserLabResultMobile
                key={t._id}
                id={t._id}
                petName={t?.petId}
                date={t.createdAt}
                riskLevel={t.riskLevel}
                riskValue={t.riskLevel}
                result={t}
              />
            ))
          ) : (
            <span className="">{"No Lab Results Found"}</span>
          )}
          <span className="">
            {count === labTests?.length && labTests.lenght > 0 ? "No Submitted Results Found" : ""}
          </span>
        </>
      ) : (
        <div className="tw-w-[90%] tw-mx-auto tw-bg-[#FFFFFF] tw-shadow-3xl tw-rounded-xl  tw-py-7">
          <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col ">
            {/* 1st item */}
            <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">My Pets</div>
              <div className="tw-flex-1 tw-flex tw-items-center tw-text-xl tw-text-[#29223E] tw-font-medium">
                Activation Date
                <img src={Arrow} alt="arrow" />
              </div>
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">Activation Code</div>
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">Risk Level</div>
              <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold">Test Result</div>
            </div>
            {/* 2nd item */}
            {labTests && labTests.length !== 0 ? (
              labTests.map((t: any) => (
                <>
                  <LabResultRow
                    key={t._id}
                    id={t._id}
                    petName={t?.petId}
                    date={t.createdAt}
                    riskLevel={t.riskLevel}
                    riskValue={t.riskLevel}
                    result={t}
                  />
                </>
              ))
            ) : (
              <span className="">{"No Lab Results Found"}</span>
            )}
            <span className="">
              {count === labTests?.length && labTests.lenght > 0 ? "No Submitted Results Found" : ""}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default UserLabResult;
